class WishlistIndicator extends HTMLElement {
  connectedCallback() {
    this.svg = this.querySelector("svg");
    this.dot = this.querySelector(".wishlist-dot");
    this.update();
    window.addEventListener("wishlist:updated", () => this.update());
  }
  update() {
    try {
      const wishlist = JSON.parse(
        localStorage.getItem("shopify_wishlist") || "[]"
      );
      const hasItems = wishlist.length > 0;
      if (this.svg) {
        if (hasItems) {
          this.svg.setAttribute("fill", "currentColor");
          this.svg.classList.remove("text-white");
          this.svg.classList.add("text-red");
        } else {
          this.svg.setAttribute("fill", "none");
          this.svg.classList.remove("text-red");
          this.svg.classList.add("text-white");
        }
      }
      if (this.dot) {
        this.dot.classList.toggle("hidden", !hasItems);
      }
    } catch (e) {
    }
  }
}
customElements.define("wishlist-indicator", WishlistIndicator);
